import { AutoSizer, List } from 'react-virtualized';
import type { ListRowProps } from 'react-virtualized';
import type { ReactNode } from 'react';

export interface VirtualizedListProps<T> {
  keyGroup: string;
  items: Array<T>;
  itemHeight: number;
  overscanRowCount?: number;
  noItemsComponent?: ReactNode;
  className?: string;
  children: (item: T, index: number) => ReactNode;
}

export function VirtualizedList<T>({
  keyGroup,
  items,
  itemHeight,
  overscanRowCount = 5,
  noItemsComponent = null,
  className = '',
  children
}: VirtualizedListProps<T>) {
  if (items.length === 0 && noItemsComponent) {
    return <div className={className}>{noItemsComponent}</div>;
  }

  const rowRenderer = ({ index, key, style }: ListRowProps) => {
    const item = items[index];
    return (
      <div key={`${keyGroup}-${key}`} style={style}>
        {children(item, index)}
      </div>
    );
  };

  return (
    <div className={`size-full ${className}`}>
      <AutoSizer>
        {({ width, height }) => {
          return (
            <List
              width={width}
              height={height}
              rowCount={items.length}
              rowHeight={itemHeight}
              rowRenderer={rowRenderer}
              overscanRowCount={overscanRowCount}
            />
          );
        }}
      </AutoSizer>
    </div>
  );
}
